import data from "../../../../../src/SegmentedControl/SegmentedControl.docs.json";
import * as React from 'react';
export default {
  data,
  React
};